export default {
  namespaced: true,
  state: {
    isShowArtifactList: false,
    selectedCity: { code: '440000', value: '全省' },
    selectCategorieUid: [],
    selectCategorieName: '',
    moreOptionsId: []
  },
  getters: {
    isShowArtifactList: state => state.isShowArtifactList,
    selectedCity: state => state.selectedCity,
    selectCategorieName: state => state.selectCategorieName,
    selectCategorieUid: state => state.selectCategorieUid,
    moreOptionsId: state => state.moreOptionsId
  },
  mutations: {
    setIsShowArtifactList (state, status) {
      state.isShowArtifactList = status
    },
    setSelectedCity (state, params) {
      state.selectedCity = params
    },
    setMoreOptionsId (state, params) {
      if (state.moreOptionsId.indexOf(params) === -1) {
        state.moreOptionsId = [params]
      }
    },
    setMoreOptionsIdByArr (state, params) {
      state.moreOptionsId = params
    },
    setSelectCategorieUid (state, params) {
      if (state.selectCategorieUid.indexOf(params) === -1) {
        state.moreOptionsId = []
        state.selectCategorieUid = [params]
      }
    },
    setSelectCategorieName (state, params) {
      state.selectCategorieName = params
    }
  },
  actions: {}
}
